"use strict";

require("core-js/modules/es.promise.finally.js");

function e(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var t = require("react"),
    n = e(t),
    r = e(require("gotrue-js"));

function o() {
  return (o = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var i = {
  token: void 0,
  type: void 0,
  error: void 0,
  status: void 0
},
    u = /(confirmation|invite|recovery|email_change|access)_token=([^&]+)/,
    a = /error=access_denied&error_description=403/,
    c = /^#\/?/,
    s = {
  autoconfirm: !1,
  disable_signup: !1,
  external: {
    bitbucket: !1,
    email: !0,
    facebook: !1,
    github: !1,
    gitlab: !1,
    google: !1
  }
},
    f = "No current user found - are you logged in?",
    l = p(),
    d = l[1],
    v = l[0];

function h(e, n, l) {
  void 0 === n && (n = function n() {}), void 0 === l && (l = !0);
  var d = t.useMemo(function () {
    return new r({
      APIUrl: e + "/.netlify/identity",
      setCookie: !0
    });
  }, [e]),
      v = t.useState(d.currentUser() || void 0),
      h = v[0],
      p = v[1],
      k = t.useCallback(function (e) {
    return p(e), n(e), e;
  }, [n]),
      y = t.useState(i),
      g = y[0],
      m = y[1];
  t.useEffect(function () {
    if (l) {
      var e = function (e, t, n) {
        var r, s;
        if (void 0 === n && (n = !0), !(null === (r = document) || void 0 === r ? void 0 : null === (s = r.location) || void 0 === s ? void 0 : s.hash)) return i;
        var f = document.location.hash.replace(c, "");

        try {
          history.pushState("", document.title, window.location.pathname + window.location.search);
        } catch (e) {
          window.location.href.substr(0, window.location.href.indexOf("#"));
        }

        if (f.match(a)) return o({}, i, {
          error: "access_denied",
          status: 403
        });
        var l = f.match(u);

        if (l) {
          var d = function (e) {
            return e.split("&").reduce(function (e, t) {
              var n,
                  r = t.split("=");
              return o({}, e, ((n = {})[r[0]] = r[1], n));
            }, {});
          }(f);

          return d.confirmation_token ? (e.confirm(d.confirmation_token, n).then(t).catch(console.error), i) : d.access_token ? (document.cookie = "nf_jwt=" + d.access_token, e.createUser(d, n).then(t).catch(console.error), i) : o({}, i, {
            type: l[1],
            token: l[2]
          });
        }

        return i;
      }(d, k);

      (e.token || e.error) && m(e);
    }
  }, []);
  var b = t.useState(s),
      w = b[0],
      C = b[1];
  t.useEffect(function () {
    d.settings.bind(d)().then(function (e) {
      return C(e);
    });
  }, []);

  var j = t.useCallback(function (e) {
    var t = d.loginExternalUrl(e);
    window.location.href = t;
  }, [d]),
      P = t.useCallback(function (e, t) {
    if (void 0 === t && (t = !0), g.token && "invite" === g.type) {
      var n = d.acceptInviteExternalUrl(e, g.token);
      if (m(i), !t) return n;
      window.location.href = n;
    } else console.error("either no token found or invalid for this purpose");
  }, [d, g]),
      _ = t.useCallback(function () {
    return g.type && g.token ? d.verify(g.type, g.token).then(function (e) {
      return m(i), e;
    }) : Promise.reject("either no token found or invalid for this purpose");
  }, [d, g]),
      x = t.useCallback(function (e, t, n, r) {
    return void 0 === r && (r = !0), d.signup(e, t, n).then(function (e) {
      return r ? k(e) : e;
    });
  }, [d, k]),
      U = t.useCallback(function (e, t, n) {
    return void 0 === n && (n = !0), d.login(e, t, n).then(k);
  }, [d, k]),
      E = t.useCallback(function (e) {
    return d.requestPasswordRecovery(e);
  }, [d]),
      T = t.useCallback(function (e) {
    return g.token && "recovery" === g.type ? d.recover(g.token, e).then(function (e) {
      return k(e);
    }).finally(function () {
      m(i);
    }) : Promise.reject("either no token found or invalid for this purpose");
  }, [d, k, g]),
      I = t.useCallback(function (e) {
    return h ? h.update(e).then(k) : Promise.reject(f);
  }, [h]),
      S = t.useCallback(function () {
    return h ? h.jwt() : Promise.reject(f);
  }, [h]),
      O = t.useCallback(function () {
    return h ? h.logout().then(function () {
      return k(void 0);
    }) : Promise.reject(f);
  }, [h]),
      z = function z(e) {
    return function (t, n) {
      var r;
      if (void 0 === n && (n = {}), !(null == h ? void 0 : null === (r = h.token) || void 0 === r ? void 0 : r.access_token)) return Promise.reject("no user token found");
      var o = Object.assign({
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + h.token.access_token
        }
      }, {
        method: e
      }, n);
      return fetch(t, o).then(function (e) {
        return "application/json" === o.headers["Content-Type"] ? e.json() : e;
      });
    };
  },
      A = {
    get: z("GET"),
    post: z("POST"),
    put: z("PUT"),
    delete: z("DELETE")
  };

  return {
    user: h,
    setUser: k,
    isConfirmedUser: !(!h || !h.confirmed_at),
    isLoggedIn: !!h,
    signupUser: x,
    loginUser: U,
    logoutUser: O,
    requestPasswordRecovery: E,
    recoverAccount: T,
    updateUser: I,
    getFreshJWT: S,
    authedFetch: A,
    _goTrueInstance: d,
    _url: e,
    loginProvider: j,
    acceptInviteExternalUrl: P,
    settings: w,
    param: g,
    verifyToken: _
  };
}

function p() {
  var e = t.createContext(void 0);
  return [function () {
    var n = t.useContext(e);
    if (!n) throw new Error("useCtx must be inside a Provider with a value");
    return n;
  }, e.Provider];
}

exports.IdentityContextProvider = function (e) {
  var t = e.url,
      r = e.children,
      o = e.onAuthChange,
      i = void 0 === o ? function () {} : o;
  if (!t || !/^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i.test(t)) throw new Error("invalid netlify instance URL: " + t + ". Please check the docs for proper usage or file an issue.");
  var u = h(t, i);
  return n.createElement(d, {
    value: u
  }, r);
}, exports.useIdentityContext = v, exports.useNetlifyIdentity = h;